export default __webpack_public_path__ + "static/media/profile.7af477b1.png";